<template>
    <div class="facebook-stars">
        <div class="facebook-stars__rating">
            {{ stars }}
        </div>

        <div class="facebook-stars__stars">
            <div
                v-for="i in 5"
                :key="i"
                class="facebook-stars__star"
            >
                <!-- Show full star -->
                <svg
                    v-if="i <= stars"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 18 18"
                    width="16"
                    height="16"
                >
                    <polygon
                        fill="#ffb32f"
                        points="9,0 11.44,6.42 18,6.88 12.95,11.3 14.56,18 9,14.32 3.44,18 5.05,11.3 0,6.88 6.56,6.42"
                    />
                </svg>

                <!-- Show partially filled star -->
                <svg
                    v-else-if="Math.ceil(stars) === i && stars % 1 > 0"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 18 18"
                    width="16"
                    height="16"
                >
                    <polygon
                        fill="#d2d2d1"
                        points="9,0 11.44,6.42 18,6.88 12.95,11.3 14.56,18 9,14.32 3.44,18 5.05,11.3 0,6.88 6.56,6.42"
                    />
                    <polygon
                        :style="{'clip-path': getClipPath}"
                        fill="#ffb32f"
                        points="9,0 11.44,6.42 18,6.88 12.95,11.3 14.56,18 9,14.32 3.44,18 5.05,11.3 0,6.88 6.56,6.42"
                    />
                </svg>

                <!-- Show empty star -->
                <svg
                    v-else
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 18 18"
                    width="16"
                    height="16"
                >
                    <polygon
                        fill="#d2d2d1"
                        points="9,0 11.44,6.42 18,6.88 12.95,11.3 14.56,18 9,14.32 3.44,18 5.05,11.3 0,6.88 6.56,6.42"
                    />
                </svg>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    stars: {
        type: Number,
        required: true,
        default: 5,
    },
});

const getClipPath = computed(() => {
    const percentage = props.stars % 1 * 100 + '%';
    return `polygon(0 0, ${percentage} 0, ${percentage} 100%, 0 100%)`;
});
</script>

<style lang="scss">
@use "watson-atom-variation-facebook";
</style>
